export class StatusType {
    static OK: string = 'OK';
    static CREATED: string = 'CREATED';
    static NO_CONTENT: string = 'NO_CONTENT';
    static BAD_REQUEST: string = 'BAD_REQUEST';
    static UNAUTHORIZED: string = 'UNAUTHORIZED';
    static FORBIDDEN: string = 'FORBIDDEN';
    static NOT_FOUND: string = 'NOT_FOUND';
    static METHOD_NOT_ALLOWED: string = 'METHOD_NOT_ALLOWED';
    static CONFLICT: string = 'CONFLICT';
    static INTERNAL_SERVER_ERROR: string = 'INTERNAL_SERVER_ERROR';
    static NOT_IMPLEMENTED: string = 'NOT_IMPLEMENTED';
    static BAD_GATEWAY: string = 'BAD_GATEWAY';
    static SERVICE_UNAVAILABLE: string = 'SERVICE_UNAVAILABLE';
    static GATEWAY_TIMEOUT: string = 'GATEWAY_TIMEOUT';
    static ERROR : string = 'ERROR';
}